import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";
import { BACKEND_BASEURL } from "@/config/config";

export const useEnergyDataRequestStore = defineStore('energyDataRequest', () => {
    const requests = ref([]);
    const currentRequest = ref(null);
    const loading = ref(false);

    async function fetchRequests(ecn) {
        loading.value = true;
        try {
            const response = await axios.get(`${BACKEND_BASEURL}energyDataRequests/${ecn}`);
            requests.value = response.data;
        } catch (error) {
            console.error('Failed to fetch energy data requests:', error);
        } finally {
            loading.value = false;
        }
    }

    async function fetchRequestById(ecn, id) {
        loading.value = true;
        try {
            const response = await axios.get(`${BACKEND_BASEURL}energyDataRequests/${ecn}/${id}`);
            currentRequest.value = response.data;
            return response.data;
        } catch (error) {
            console.error('Failed to fetch energy data request:', error);
        } finally {
            loading.value = false;
        }
    }

    async function startBatchRequest(ecn, dateStart, dateEnd, ecid, triggeredBy, meteringPointIds) {
        loading.value = true;
        try {
            const response = await axios.post(`${BACKEND_BASEURL}energyDataRequests/${ecn}/start`, {
                dateStart,
                dateEnd,
                ecid,
                triggeredBy: triggeredBy || 'ADMIN_UI',
                meteringPointIds,
            });
            requests.value.unshift(response.data);
            return response.data;
        } catch (error) {
            console.error('Failed to start batch energy data request:', error);
            throw error;
        } finally {
            loading.value = false;
        }
    }

    return {
        requests,
        currentRequest,
        loading,
        fetchRequests,
        fetchRequestById,
        startBatchRequest,
    };
});
